import BaseService from "@root/core/class/BaseService";

class MetaService extends BaseService {

  public getMetaData = () => {
    return this.get("api/v1/metadata");
  };
}

export default new MetaService("/", false);
